<template lang="html">
  <div class="">
    <ServiceSubheader />
    <p>Team Members</p>
    <TeamMembersComponent />
  </div>
</template>

<script>
import ServiceSubheader from '../../components/ServiceComponents/ServiceSubheader';
import TeamMembersComponent from '../../components/ServiceComponents/TeamMembersComponent';
export default {
  name: "TeamMembersPage",
  components: {
    ServiceSubheader,
    TeamMembersComponent
  }
}
</script>

<style lang="css" scoped>
div p{
  color: rgb(60, 3, 140);
  font-size: 36px;
  font-weight: bold;
}
</style>
